import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export const COOKIE_CONSENT_KEY = 'diobuch_cookie_consent_v1';
/** Старый ключ «Понятно» — согласием на аналитику не считаем. */
const LEGACY_NOTICE_KEY = 'diobuch_cookie_notice_v1';

function readConsent() {
  try {
    return window.localStorage.getItem(COOKIE_CONSENT_KEY);
  } catch {
    return null;
  }
}

function writeConsent(value) {
  try {
    window.localStorage.setItem(COOKIE_CONSENT_KEY, value);
    window.localStorage.removeItem(LEGACY_NOTICE_KEY);
  } catch {
    /* ignore quota / private mode */
  }
}

function clearYandexCookies() {
  document.cookie.split(';').forEach((part) => {
    const name = part.trim().split('=')[0];
    if (!name) return;
    if (name.startsWith('_ym') || name.startsWith('yandexuid') || name === 'yp' || name === 'ys') {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax`;
    }
  });
}

function getMetrikaId() {
  const raw = window.__YANDEX_METRIKA_ID__;
  if (raw == null || raw === '') return 0;
  const id = Number(raw);
  return Number.isFinite(id) && id > 0 ? id : 0;
}

let metrikaLoaded = false;

export function loadYandexMetrika() {
  const id = getMetrikaId();
  if (metrikaLoaded || !id) return;
  metrikaLoaded = true;
  (function (m, e, t, r, i, k, a) {
    m[i] =
      m[i] ||
      function () {
        (m[i].a = m[i].a || []).push(arguments);
      };
    m[i].l = 1 * new Date();
    for (let j = 0; j < document.scripts.length; j += 1) {
      if (document.scripts[j].src === r) return;
    }
    k = e.createElement(t);
    a = e.getElementsByTagName(t)[0];
    k.async = 1;
    k.src = r;
    a.parentNode.insertBefore(k, a);
  })(window, document, 'script', `https://mc.yandex.ru/metrika/tag.js?id=${id}`, 'ym');

  window.ym(id, 'init', {
    ssr: true,
    webvisor: true,
    clickmap: true,
    referrer: document.referrer,
    url: location.href,
    accurateTrackBounce: true,
    trackLinks: true,
  });
}

export function openCookieSettings() {
  try {
    window.localStorage.removeItem(COOKIE_CONSENT_KEY);
    window.localStorage.removeItem(LEGACY_NOTICE_KEY);
  } catch {
    /* ignore */
  }
  clearYandexCookies();
  if (metrikaLoaded) {
    window.location.reload();
    return;
  }
  window.dispatchEvent(new CustomEvent('diobuch-cookie-settings'));
}

export default function CookieNotice() {
  const metrikaId = getMetrikaId();
  const [visible, setVisible] = useState(() => {
    const consent = readConsent();
    return consent !== 'analytics' && consent !== 'necessary';
  });

  useEffect(() => {
    try {
      window.localStorage.removeItem(LEGACY_NOTICE_KEY);
    } catch {
      /* ignore */
    }
    const consent = readConsent();
    if (consent === 'analytics') {
      loadYandexMetrika();
      setVisible(false);
    } else if (consent === 'necessary') {
      setVisible(false);
    }
  }, []);

  useEffect(() => {
    function onSettings() {
      setVisible(true);
    }
    window.addEventListener('diobuch-cookie-settings', onSettings);
    return () => window.removeEventListener('diobuch-cookie-settings', onSettings);
  }, []);

  useEffect(() => {
    document.body.classList.toggle('has-cookie-notice', visible);
    return () => document.body.classList.remove('has-cookie-notice');
  }, [visible]);

  function acceptAnalytics() {
    writeConsent('analytics');
    loadYandexMetrika();
    setVisible(false);
  }

  function acceptNecessary() {
    writeConsent('necessary');
    clearYandexCookies();
    setVisible(false);
  }

  if (!visible) return null;

  if (!metrikaId) {
    return (
      <div className="cookie-notice" role="region" aria-label="Уведомление о cookie">
        <p>
          Сайт использует необходимые cookie (сессия входа и защита форм).{' '}
          <Link to="/privacy">Политика обработки ПДн</Link>
        </p>
        <button type="button" className="btn btn-primary btn-sm" onClick={acceptNecessary}>
          Понятно
        </button>
      </div>
    );
  }

  return (
    <div className="cookie-notice" role="region" aria-label="Согласие на cookie и Метрику">
      <p>
        Сайт ставит необходимые cookie: сессия входа и защита форм. Статистика
        (Яндекс.Метрика, в том числе Вебвизор) включается только после вашего согласия.
        Если вам нет 14 лет, включить Метрику и Вебвизор может только родитель.{' '}
        <Link to="/privacy">Политика обработки ПДн</Link>
      </p>
      <div className="cookie-notice-actions">
        <button type="button" className="btn btn-primary btn-sm" onClick={acceptAnalytics}>
          Принять Метрику и Вебвизор
        </button>
        <button type="button" className="btn btn-secondary btn-sm" onClick={acceptNecessary}>
          Только необходимые
        </button>
      </div>
    </div>
  );
}
